module.exports = __webpack_public_path__ + "static/media/wochenbett.a196a2e3.jpg";